import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { apiKey } from "../../../../config/config";
import { useReactToPrint } from "react-to-print";

function DailySummaryReport() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [data, setData] = useState();
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Daily_Summary_Report_${date}`,
    removeAfterPrint: true,
    // black and white print
    pageStyle: `
      @media print {
        * {
          color: #000 !important;
          background: #fff !important;
          box-shadow: none !important;
          text-shadow: none !important;
        }

        body {
          -webkit-print-color-adjust: economy;
          color-adjust: economy;
        }
      }
    `,
  });

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/daily-summary-report`, {
        params: {
          outletId: user?.user.outlet_id,
          date: date,
        },
      })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [date, user?.user.outlet_id]);
  return (
    <main>
      <div className="text-d-bg-text text-3xl text-center my-8">
        Daily Summary Report
      </div>
      <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>

      <div className="md:flex block flex-wrap  gap-5 ms-4 my-2 items-center ">
        <div>
          <label htmlFor="" className="w-full lg:w-1/3">
            <span className="text-d-bg-text text-sm mb ">Date</span>
            <div className="mb-2 pt-0">
              <input
                type="date"
                className="px-2 py-2  text-gray-500 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                required
                value={date}
                onChange={(e) => setDate(e.target.value)}
              />
            </div>
          </label>
        </div>
        <button
          className="bg-d-cat-btn text-white text-sm px-3 text-center py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150 mt-3 w-fit ms-auto"
          type="button"
          onClick={handlePrint}
        >
          Print
        </button>
      </div>
      <div>
        <h1 className="text-d-bg-text text-3xl text-center ">Imdady RMS</h1>
      </div>
      <div ref={componentRef}>
        <div className="my-12">
          <div className="my-10">
            <h1 className="text-d-bg-text text-2xl text-center ">
              Daily Summary Report
            </h1>
            <p className="text-d-bg-text text-center">Date: {date}</p>
          </div>
          <table className="border-solid border-2 border-black w-full">
            <thead>
              <tr className="border-b-2 border-black ">
                <th className="py-3 border-r-2 border-black">SN</th>
                <th className="py-3 border-r-2 border-black">Reference No </th>
                <th className="py-3 border-r-2 border-black">Supplier</th>
                <th className="py-3 border-r-2 border-black">G. Total</th>
                <th className="py-3 border-r-2 border-black">Paid</th>
                <th className="py-3 border-r-2 border-black">Due</th>
              </tr>
            </thead>
            <tbody>
              {data?.supplier_report?.map((item, i) => (
                <tr key={i}>
                  <td className="py-1 px-2 border-r-2 border-black">{i + 1}</td>
                  <td className="py-1 px-2 border-r-2 border-black">
                    {item.reference_no}
                  </td>
                  <td className="py-1 px-2 border-r-2 border-black">
                    {item.supplier.name}
                  </td>
                  <td className="py-1 px-2 border-r-2 border-black">
                    {item.grand_total}
                  </td>
                  <td className="py-1 px-2 border-r-2 border-black">{item.paid}</td>
                  <td className="py-1 px-2 border-r-2 border-black">{item.due}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="text-center border-t-2 border-black">
                <td className="py-1 px-2 border-r-2 border-black"></td>
                <td className="py-1 px-2 border-r-2 border-black"></td>
                <td className="py-1 px-2 border-r-2 border-black">Sum</td>
                <td className="py-1 px-2 border-r-2 border-black">
                  {data?.supplier_report?.reduce(
                    (acc, item) => acc + Number(item.grand_total),
                    0
                  )}
                </td>
                <td className="py-1 px-2 border-r-2 border-black">
                  {data?.supplier_report?.reduce(
                    (acc, item) => acc + Number(item.paid),
                    0
                  )}
                </td>
                <td className="py-1 px-2 border-r-2 border-black">
                  {data?.supplier_report?.reduce(
                    (acc, item) => acc + Number(item.due),
                    0
                  )}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div className="my-12">
          <h1 className="text-d-bg-text my-12 text-xl text-center font-semibold">
            Sale
          </h1>
          <table className="border-solid border-2 border-black w-full">
            <thead>
              <tr className="border-b-2 border-black ">
                <th className="py-3  border-r-2 border-black">SN</th>
                <th className="py-3 border-r-2 border-black">Reference No </th>
                <th className="py-3 border-r-2 border-black">Order Type</th>
                <th className="py-3 border-r-2 border-black">Table</th>
                <th className="py-3 border-r-2 border-black">Customer</th>
                <th className="py-3 border-r-2 border-black">Total Payable</th>
                <th className="py-3 border-r-2 border-black">Discount</th>
                <th className="py-3 border-r-2 border-black">Paid</th>
                <th className="py-3 border-r-2 border-black">Due</th>
              </tr>
            </thead>
            <tbody>
              {data?.orders_report?.map((item, i) => (
                <tr>
                  <td className="py-1 px-2 border-r-2 border-black">{i + 1}</td>
                  <td className="py-1 px-2 border-r-2 border-black">
                    {item?.sale_no}
                  </td>
                  <td className="py-1 px-2 border-r-2 border-black">
                    {item?.order_type?.name}
                  </td>
                  <td className="py-1 px-2 border-r-2 border-black">
                    {item?.table?.name}
                  </td>
                  <td className="py-1 px-2 border-r-2 border-black">
                    {item.customer_id !== 0
                      ? item?.customer?.name
                      : item?.guest?.name}
                  </td>
                  <td className="py-1 px-2 border-r-2 border-black">
                    {item?.total_payable}
                  </td>
                  <td className="py-1 px-2 border-r-2 border-black">
                    {item?.total_discount_amount}
                  </td>
                  <td className="py-1 px-2 border-r-2 border-black">
                    {item?.paid_amount}
                  </td>
                  <td className="py-1 px-2 border-r-2 border-black">
                    {item?.due_amount}
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="text-center border-t-2 border-black">
                <td className="py-1 px-2 border-r-2 border-black"></td>
                <td className="py-1 px-2 border-r-2 border-black"></td>
                <td className="py-1 px-2 border-r-2 border-black"></td>
                <td className="py-1 px-2 border-r-2 border-black"></td>
                <td className="py-1 px-2 border-r-2 border-black">Sum</td>
                <td className="py-1 px-2 border-r-2 border-black">
                  {(
                    data?.orders_report?.reduce(
                      (acc, item) => acc + Number(item.total_payable),
                      0
                    ) || 0
                  ).toFixed(2)}
                </td>
                <td className="py-1 px-2 border-r-2 border-black">
                  {(
                    data?.orders_report?.reduce(
                      (acc, item) => acc + Number(item.total_discount_amount),
                      0
                    ) || 0
                  ).toFixed(2)}
                </td>
                <td className="py-1 px-2 border-r-2 border-black">
                  {(
                    data?.orders_report?.reduce(
                      (acc, item) => acc + Number(item.paid_amount),
                      0
                    ) || 0
                  ).toFixed(2)}
                </td>
                <td className="py-1 px-2 border-r-2 border-black">
                  {(
                    data?.orders_report?.reduce(
                      (acc, item) => acc + Number(item.due_amount),
                      0
                    ) || 0
                  ).toFixed(2)}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div className="my-12">
          <h1 className="text-d-bg-text my-12 text-xl text-center font-semibold">
            Expenses
          </h1>
          <table className="border-solid border-2 border-black w-full">
            <thead>
              <tr className="border-b-2 border-black ">
                <th className="py-3  border-r-2 border-black">SN</th>
                <th className="py-3 border-r-2 border-black">Amount </th>
                <th className="py-3 border-r-2 border-black">Category</th>
                <th className="py-3 border-r-2 border-black">
                  Responsible Person
                </th>
                <th className="py-3 border-r-2 border-black">Note</th>
              </tr>
            </thead>
            <tbody>
              {data?.expense_report?.map((item, index) => (
                <tr key={index} className="text-center border-t-2 border-black">
                  <td className="py-1 px-2border-r-2 border-black">{index + 1}</td>
                  <td className="py-1 px-2border-r-2 border-black">
                    {item.amount}
                  </td>
                  <td className="py-1 px-2border-r-2 border-black">
                    {item?.category?.name}
                  </td>
                  <td className="py-1 px-2border-r-2 border-black">
                    {item?.user?.name}
                  </td>
                  <td className="py-1 px-2border-r-2 border-black">{item?.note}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="text-center border-t-2 border-black">
                <td className="py-1 px-2 border-r-2 border-black">Sum</td>
                <td className="py-1 px-2 border-r-2 border-black">
                  {(
                    data?.expense_report?.reduce(
                      (acc, item) => acc + Number(item.amount),
                      0
                    ) || 0
                  ).toFixed(2)}
                </td>
                <td className="py-1 px-2 border-r-2 border-black"></td>
                <td className="py-1 px-2 border-r-2 border-black"></td>
                <td className="py-1 px-2 border-r-2 border-black"></td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div className="my-12">
          <h1 className="text-d-bg-text my-12 text-xl text-center font-semibold">
            Supplier Due Payments
          </h1>
          <table className="border-solid border-2 border-black w-full">
            <thead>
              <tr className="border-b-2 border-black ">
                <th className="py-3  border-r-2 border-black">SN</th>
                <th className="py-3 border-r-2 border-black">Amount </th>
                <th className="py-3 border-r-2 border-black">Supplier</th>
                <th className="py-3 border-r-2 border-black">Note</th>
              </tr>
            </thead>
            <tbody>
              {data?.supplier_due_report?.map((item, index) => (
                <tr key={index} className="text-center border-t-2 border-black">
                  <td className="py-1 px-2border-r-2 border-black">{index + 1}</td>
                  <td className="py-1 px-2border-r-2 border-black">{item.due}</td>
                  <td className="py-1 px-2border-r-2 border-black">
                    {item?.supplier?.name}
                  </td>
                  <td className="py-1 px-2border-r-2 border-black">{item?.note}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="text-center border-t-2 border-black">
                <td className="py-1 px-2 border-r-2 border-black">Sum</td>
                <td className="py-1 px-2 border-r-2 border-black">
                  {(
                    data?.supplier_due_report?.reduce(
                      (acc, item) => acc + Number(item.due),
                      0
                    ) || 0
                  ).toFixed(2)}
                </td>
                <td className="py-1 px-2 border-r-2 border-black"></td>
                <td className="py-1 px-2 border-r-2 border-black"></td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div className="my-12">
          <h1 className="text-d-bg-text my-12 text-xl text-center font-semibold">
            Customer Due Receives
          </h1>

          <table className="border-solid border-2 border-black w-full">
            <thead>
              <tr className="border-b-2 border-black ">
                <th className="py-3  border-r-2 border-black">SN</th>
                <th className="py-3 border-r-2 border-black">Amount </th>
                <th className="py-3 border-r-2 border-black">Customer</th>
                <th className="py-3 border-r-2 border-black">Note</th>
              </tr>
            </thead>
            <tbody>
              {data?.customer_due_report?.map((item, index) => (
                <tr key={index} className="text-center border-t-2 border-black">
                  <td className="py-1 px-2border-r-2 border-black">{index + 1}</td>
                  <td className="py-1 px-2border-r-2 border-black">
                    {item.due_amount}
                  </td>
                  <td className="py-1 px-2border-r-2 border-black">
                    {item?.customer?.name}
                  </td>
                  <td className="py-1 px-2border-r-2 border-black">{item?.order_note}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="text-center">
                <td className="py-1 px-2 border-r-2 border-black">Sum</td>
                <td className="py-1 px-2 border-r-2 border-black">
                  {(
                    data?.customer_due_report?.reduce(
                      (acc, item) => acc + Number(item.due_amount),
                      0
                    ) || 0
                  ).toFixed(2)}
                </td>
                <td className="py-1 px-2 border-r-2 border-black"></td>
                <td className="py-1 px-2 border-r-2 border-black"></td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div className="my-12">
          <h1 className="text-d-bg-text my-12 text-xl text-center font-semibold">
            Waste
          </h1>

          <table className="border-solid border-2 border-black w-full">
            <thead>
              <tr className="border-b-2 border-black ">
                <th className="py-3  border-r-2 border-black">SN</th>
                <th className="py-3 border-r-2 border-black">Reference No </th>
                <th className="py-3 border-r-2 border-black">Loss Amount</th>
                <th className="py-3 border-r-2 border-black">
                  Responsible Person
                </th>
                <th className="py-3 border-r-2 border-black">Note</th>
              </tr>
            </thead>
            <tbody>
              {data?.waste_report?.map((item, index) => (
                <tr key={index} className="text-center border-t-2 border-black">
                  <td className="py-1 px-2border-r-2 border-black">{index + 1}</td>
                  <td className="py-1 px-2border-r-2 border-black">
                    {item?.reference_no}
                  </td>
                  <td className="py-1 px-2border-r-2 border-black">
                    {item?.total_loss}
                  </td>
                  <td className="py-1 px-2border-r-2 border-black">
                    {item?.responsible_person?.name}
                  </td>
                  <td className="py-1 px-2border-r-2 border-black">{item?.note}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="text-center border-t-2 border-black">
                <td className="py-1 px-2 border-r-2 border-black">Sum</td>
                <td className="py-1 px-2 border-r-2 border-black">
                  {(
                    data?.waste_report?.reduce(
                      (acc, item) => acc + Number(item.total_loss),
                      0
                    ) || 0
                  ).toFixed(2)}
                </td>
                <td className="py-1 px-2 border-r-2 border-black"></td>
                <td className="py-1 px-2 border-r-2 border-black"></td>
                <td className="py-1 px-2 border-r-2 border-black"></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </main>
  );
}

export default DailySummaryReport;
